<template>
  <div class="content">
    <!-- 基本信息 -->
    <div class="content-box content-scheme">
      <div class="lease-box">
        <div class="info">
          <!--  -->
          <custom-table
            :data="leaseForm.contractList"
            :column="tableColumn"
            :span-method="cellMerge"
            style="width: 100%"
          >
            <!-- 操作列 -->
            <el-table-column
              :label="$t('Common.com_handle')"
              width="180"
              fixed="right"
              v-if="tableColumn.length"
            >
              <template slot-scope="scope">
                <span></span>
                <el-button
                  type="text"
                  size="mini"
                  @click="editLeaseItem(scope.row)"
                  >{{$t('crm_contract_scheme_supplies.bian_ji_fang_an')}}</el-button
                >
                <el-button
                  type="text"
                  size="mini"
                  @click="deleteLeaseItem(scope.row.goodsId)"
                  >{{$t('Common.com_delete')}}</el-button
                >
              </template>
            </el-table-column>
          </custom-table>
        </div>
        <div class="lease-add-btn" @click="addLeaseItem">
          <div style="display: inline-block">
            <i class="icon icon-add"></i>
            <span>{{
              $t('crm_contract_scheme_supplies.tjsbzlxx')
            }}</span>
          </div>
        </div>
      </div>
      <div class="supplies-box">
        <div class="supplies-list">
          <ul>
            <li>
              <div class="ub formContact-title item">
                <el-row :gutter="10" class="ub-f1">
                  <el-col :span="1">#</el-col>
                  <el-col :span="6">{{
                    $t('crm_contract_scheme_supplies.chan_pin_xing_hao')
                  }}</el-col>
                  <el-col :span="6">{{
                    $t('crm_contract_scheme_supplies.hcysjmc')
                  }}</el-col>
                  <el-col :span="3">{{
                    $t('crm_contract_scheme_supplies.dai_ma')
                  }}</el-col>
                  <el-col :span="3">{{
                    $t('crm_contract_scheme_supplies.shu_liang')
                  }}</el-col>
                  <el-col :span="3">{{
                    $t('crm_contract_scheme_supplies.dan_jia')
                  }}</el-col>
                  <el-col :span="2">{{
                    $t('Common.com_handle')
                  }}</el-col>
                </el-row>
              </div>
            </li>
            <li v-for="(item, index) in leaseForm.stuffList" :key="index">
              <div class="item ub">
                <el-row :gutter="10" class="ub-f1">
                  <el-col :span="1">
                    <div class="index">
                       {{ index + 1 }}
                    </div>
                  </el-col>
                  <el-col :span="6">
                    <el-select
                      v-model="item.productCode"
                      :placeholder="$t('Common.com_please_select')"
                    >
                      <el-option
                        v-for="item in productCodelist"
                        :key="item"
                        :label="item"
                        :value="item"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="6">
                    <custom-select
                      url="smsGoodsSelectList"
                      :listener="`${item.productCode}`"
                      v-model="item.goodsSkuId"
                      :props="{ label: 'goodsName', value: 'goodsSkuId'}"
                      :params="{productCode:item.productCode}"
                      :placeholder="$t('Common.com_please_select')"
                      @change="onGoodsSelect(...arguments,item)"
                      width="100%"
                    ></custom-select>
                  </el-col>
                  <el-col :span="3">
                    <div class="code">
                      {{item.goodsCode}}
                    </div>
                  </el-col>
                  <el-col :span="3">
                    <el-input
                      v-model.number="item.bookingNum"
                      style="width=100%;height=30px"
                    ></el-input>
                  </el-col>
                  <el-col :span="3">
                    <el-input
                      v-model="item.salePrice"
                      style="width=100%;height=30px"
                    ></el-input>
                  </el-col>
                  <el-col :span="2">
                    <div class="icon-box" @click="deleteStuffItem(index)">
                      <i class="icon icon-shanchu"></i>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </li>
          </ul>
        </div>
        <div class="lease-add-btn" @click="addStuffItem">
          <div style="display: inline-block">
            <i class="icon icon-add"></i>
            <span>{{ $t('Common.com_added')}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="btn-group">
      <el-button @click="onCancel">{{$t('Common.com_cancel')}}</el-button>
      <el-button @click="preStep">{{
        $t('crm_contract_scheme_supplies.sybhtxx')
      }}</el-button>
      <el-button type="primary" @click="saveScheme">{{
        $t('crm_contract_scheme_supplies.xybsczzht')
      }}</el-button>
    </div>
    <!-- 选择方案 -->
    <contractManagement-addLeaseColumn-dialog
      v-if="dialogVisible"
      :data="dialogData"
      :model="dialogModel"
      @close="dialogVisible = false"
      @success="addLeaseList"
    ></contractManagement-addLeaseColumn-dialog>
    <!-- 修改租赁方案 -->
    <contract-edit-lease
      v-if="dialogVisible1"
      :model="dialogModel1"
      @close="dialogVisible1 = false"
      @success="updateLeaseList"
    ></contract-edit-lease>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import contractManagementAddLeaseColumnDialog from './contractManagement_addLeaseColumn_dialog.vue';
import contractEditLease from './contract_edit_lease.vue';

export default {
  components: {
    contractManagementAddLeaseColumnDialog,
    contractEditLease,
  },
  inject: ['getContractInfo'],
  computed: {
    contractInfo() {
      return this.getContractInfo();
    },
  },
  props: {
    contractId: [String, Number],
    contractClass: [String, Number],
    operateFlag: [String],
  },

  data() {
    return {
      tableCode: 'contract_scheme_supplies',
      // 租赁方案
      leaseForm: {
        contractList: [
        ],
        stuffList: [],
      },
      stuffitem: {
        // 产品型号
        productCode: '',
        // 销售商品SKU
        goodsSkuId: '',
        // 商品编码
        goodsCode: '',
        // 数量
        bookingNum: '',
        // 售卖单价
        salePrice: '',
        // 货币单位
        currencyUnit: '',
        // 商品名称
        goodsName: '',
        // 商品规格
        goodsSpec: '',
        // 商品类型
        goodsType: '',
        // // 允许使用的间隔（月）
        // useInterval: ''

      },
      productCodelist: [],
      // 选择收货地址
      dialogVisible: false,
      dialogModel: {},
      dialogData: {},
      // 修改租赁方案
      dialogVisible1: false,
      dialogModel1: {},
      dialogData1: {},

      spanArr: []
    };
  },
  mounted() {
    // this.factoryId = this.getJump('factoryId');
    // this.contractId = this.contractId || '';

    this.getTableColumn();
    this.getCompanyDetail();

  },
  methods: {
    getCompanyDetail: function () {
      if (!this.contractId) {
        return;
      }
      this.$getJSON(apis.crmContractListScheme, {
        bizId: this.contractId,
        bizClass: this.contractClass,
      }).then((res) => {
        const data = res.data;
        // data.forEach((i) => {
        //   i.edit = false;
        //   i.hqShipTo = `${i.hqShipTo}`;

        //   // 如果是一次性付清 0 就改为一期
        //   // if (i.paymentPeriod === '0') {
        //   //   i.paymentPeriodSlef = i.rentalTerm;
        //   // } else {
        //   //   i.paymentPeriodSlef = i.paymentPeriod;
        //   // }
        // });
        this.leaseForm.contractList = data.goodsSkuList || [];
        this.leaseForm.stuffList = data.stuffList || [];

        this.getSpanArr();
        this.setProductCode();
      });
    },
    // 选择方案弹窗回调
    addLeaseList: function (list) {
      // productCode
      // 去除重叠的型号
      // const concatArr = this.leaseForm.contractList.concat(
      //   list.filter(
      //     item => !this.leaseForm.contractList.find(
      //       inItem => inItem.goodsSkuId === item.goodsSkuId
      //     )
      //   )
      // );
      const schemeList = Array.from(this.leaseForm.contractList);
      list.forEach((l) => {
        schemeList.push(l);
      });
      // const newchemeList = Array.from(new Set(schemeList));
      const newchemeList = this.unique(schemeList);

      // console.log(newchemeList, Array.from(new Set(schemeList)));
      this.leaseForm.contractList = newchemeList;

      this.getSpanArr();
      this.setProductCode();
    },

    unique: function (array) {
      var obj = {};
      // eslint-disable-next-line no-return-assign
      return array.filter(item => (obj.hasOwnProperty(typeof item + JSON.stringify(item)) ? false : (obj[typeof item + JSON.stringify(item)] = true)));
    },


    setProductCode: function () {
      const list = [];
      // this.leaseForm.contractList.forEach(i => list.push(i.productCode));
      this.leaseForm.contractList.map(i => list.push(i.productCode));
      this.productCodelist = Array.from(new Set(list));
    },
    // 租赁方案
    saveScheme: function () {
      // 方案表单验证  || !t.goodsId 暂时不用
      const hasEmpty = this.leaseForm.stuffList.find(
        t => !t.productCode || t.bookingNum === '' || t.salePrice === ''
      );
      if (hasEmpty) {
        this.$message.error(this.$t('crm_contract_scheme_supplies.qjhctxwz'));
        return;
      }

      // 耗材单价保留两位小数
      this.leaseForm.stuffList.forEach((item) => {
        item.salePrice = parseFloat(item.salePrice).toFixed(2);
      });

      const goodsSkuIdList = this.leaseForm.contractList.map(i => i.goodsSkuId);
      // 保存更改租赁方案
      this.$postJSON(apis.crmContractSaveScheme, {
        bizClass: this.contractClass,
        bizId: this.contractId,
        operateFlag: this.operateFlag,
        goodsSkuIdList: goodsSkuIdList,
        stuffList: this.leaseForm.stuffList,
      }).then((res) => {
        if (res.code === 0) {
          this.$message({
            message: this.$t('Common.com_save_success'),
            type: 'success',
          });
          // 上传纸质合同
          this.$emit('success', 5);
        }
      });
    },
    // 新增方案弹窗
    addLeaseItem: function () {
      this.dialogVisible = true;
      this.dialogModel.title = this.$t('crm_contract_scheme_supplies.xzzlfa');
    },
    // 删除方案项
    deleteLeaseItem: function (goodsId) {
      const filterList = this.leaseForm.contractList.filter(item => item.goodsId !== goodsId);
      this.leaseForm.contractList = filterList;
      this.getSpanArr();
    },
    // 选择方案弹窗回调
    editLeaseItem: function (item) {
      this.dialogVisible1 = true;
      this.dialogModel1.title = this.$t('crm_contract_scheme_supplies.xgzlfa');
      this.dialogModel1.goodsId = item.goodsId;
      this.dialogModel1.orgId = item.orgId;
      this.dialogModel1.categoryId = item.categoryId;
      this.dialogModel1.bigCustomerId = this.contractInfo.customerId;
    },
    // 表格合并
    getSpanArr() {
      this.spanArr = [];
      let index = 0;
      this.leaseForm.contractList.sort((a, b) => a.goodsId - b.goodsId);
      this.leaseForm.contractList.forEach((item, i) => {
        if (i === 0) {
          this.spanArr.push(1);
          this.pos = 0;
          ++index;
          this.$set(item, 'index', index);
        } else {
          // 判断当前元素与上一个元素是否相同
          if (item.goodsId === this.leaseForm.contractList[i - 1].goodsId) {
            this.spanArr[this.pos] += 1;
            this.spanArr.push(0);
          } else {
            this.spanArr.push(1);
            this.pos = i;
            // item.index=++index
            ++index;
            this.$set(item, 'index', index);
          }
        }
      });
    },
    cellMerge: function ({ rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col
        };
      } else if (columnIndex === 11) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col
        };
      }
      return false;
    },

    // 修改方案弹窗回调
    updateLeaseList: function (list) {
      const filterList = this.leaseForm.contractList.filter(item => item.goodsId !== this.dialogModel1.goodsId);
      this.leaseForm.contractList = filterList.concat(list);
      this.getSpanArr();
    },
    // 耗材下拉
    onGoodsSelect: function (data, item) {
      if (item.goodsSkuId) {
        this.$setFormatData(item, data);
      }

    },
    // 添加耗材项
    addStuffItem: function () {
      this.leaseForm.stuffList.push(JSON.parse(JSON.stringify(this.stuffitem)));
    },
    // 删除方案项
    deleteStuffItem: function (index) {
      this.leaseForm.stuffList.splice(index, 1);
    },
    // 取消
    onCancel: function () {
      this.$emit('cancelJump');
    },
    preStep: function () {
      this.$emit('previous');
    },
  },
};
</script>

<style lang="scss">
@import "@/style/colors.scss";
.content-scheme {
  padding: 14px 24px 0;
  table {
    border-collapse: collapse;
  }
  .el-table .cell {
    // color: #FFFFFF;

    color: rgba(57, 70, 104, 1);
  }
  .el-table .el-table__row td {
    // display: inline-block;
    // width: 100%;
    margin-top: 16px;
    // background: #f5f5fa;
    color: rgba(57, 70, 104, 1);
    border: 0 !important;
  }
  .el-table tr {
    // background: #f5f5fa;
    border: 1px solid #f2f3fb;
    color: rgba(57, 70, 104, 1);
    th .cell {
      color: #636e78;
    }
  }
  .el-table__expanded-cell[class*="cell"] {
    padding: 0;
  }
  .tab-wrap {
    // padding: 0 24px;
    .wrap-form {
      background: #ffffff;
      padding: 10px 24px 0;
      .wrap-form-row {
        background: #ffffff;
        padding: 10px 14px 0;
        background: #f8f9fb;
      }
    }
    .rent-amount {
      background: #ffffff;
      padding: 0 8px;
      display: flex;
      li {
        width: 100px;
        margin: 20px 16px 12px;
        border-right: 1px solid rgba(0, 0, 0, 0.05);
        height: 50px;
        .title {
          height: 16px;
          font-size: 12px;
          font-weight: bold;
          color: #495057;
          line-height: 16px;
        }
        .amount {
          margin-top: 6px;
          height: 28px;
          font-size: 12px;
          font-weight: bold;
          color: #0d9ae0;
          line-height: 28px;
        }
        &:last-of-type {
          border: 0;
        }
      }
    }
  }

  .lease-add-btn {
    line-height: 50px;
    text-align: center;
    color: rgba(73, 80, 87, 1);
    font-size: 12px;
    margin: 16px 0 16px;
    height: 50px;
    background: #f6f7fb;
    border: 1px dashed rgba(53, 184, 224, 0.3);
    cursor: pointer;
    span {
      line-height: 50px;
    }
    .icon {
      color: #00afff;
      font-size: 12px;
      margin-right: 8px;
      display: inline-block;
      line-height: 50px;
      height: 50px;
      // float: left;
    }
  }


  // .rule-action-bd {
  .supplies-list{
    ul li {
      margin-top: 10px;
      margin-bottom: 10px;
      // border: 1px solid rgba(228, 228, 228, 1);
      &:first-child {
        margin-top: 0;
      }
    }
    .formContact-title {
      // height: 30px;
      // line-height: 30px;
      background: rgba(228, 228, 228, 1);
      color: #636E78;
      font-size: 12px;
      // padding: 0 10px;
    }
    .item {
      padding: 10px;
      background: rgba(245, 245, 245, 1);
      border: 1px solid rgba(228, 228, 228, 1);
      .index,.code{
        line-height: 32px;
        height: 32px;
        color: #6C757D;
        width: 100%;
      }

      .icon-box {
        line-height: 32px;
        width: 32px;
        // margin-left: 10px;
        text-align: center;
        .icon {
          color: #00afff;
          font-size: 14px;
          cursor: pointer;
        }
      }
    }

  }
  .add-child-btn {
    background: rgba(245, 245, 245, 1);
    border: 1px dashed rgba(228, 228, 228, 1);
    line-height: 30px;
    text-align: center;
    color: #333333;
    font-size: 12px;
    margin: 0 10px;
    cursor: pointer;
    .icon {
      color: #00afff;
      font-size: 10px;
      margin-right: 8px;
      float: left;
    }
  }
  .role-add-btn {
    background: rgba(245, 245, 245, 1);
    border: 1px dashed rgba(228, 228, 228, 1);
    line-height: 40px;
    text-align: center;
    color: #333333;
    font-size: 12px;
    margin-top: 10px;
    cursor: pointer;
    .icon {
      color: #00afff;
      font-size: 10px;
      margin-right: 8px;
      float: left;
    }
  }

}
</style>
